import {Tuple} from "../../objects/common/Tuple";

export interface EnumItem<E> {
    Id: E;
    Name: keyof E;
}
/**
 * Created by alex.y on 8/9/2017.
 */
export class EnumUtil {

    public static convertEnumToTuple(enumType: any): Array<Tuple<number, string>> {
        let result = [];

        for (let en in enumType) {
            if (isNaN(enumType[en]) && en != '0')
                result.push(new Tuple(+en, enumType[en].toString()))
        }
        return result;
    }

    public static checkFlag(enm: number, flag: number): boolean {
        // tslint:disable-next-line:no-bitwise
        return (enm & flag) === flag;
    }

    // tslint:disable-next-line:variable-name
    public static getKeys<T>(_enum: T): string[] {
        const keys = Object.keys(_enum);
        const halfLength = keys.length / 2;

        return keys.splice(halfLength, halfLength);
    }

    public static enumToArray<E>(Enum: E,
                                 exclude: any[] = [],
                                 isString: boolean = false): EnumItem<E>[] {
        if (isString) {
            return Object.keys(Enum)
                .filter((key: any) => !exclude.includes(key))
                .map((key: any) => ({Id: key, Name: Enum[key]} as EnumItem<E>));
        }

        return Object.keys(Enum)
            .filter((key: any) => !isNaN(Number(Enum[key])))
            .filter((key: any) => !exclude.includes(Enum[key]))
            .map((key: any) => ({Id: Enum[key], Name: key} as EnumItem<E>));
    }

    public static enumToObject<E>(Enum: any,
                                  exclude: any[] = [],
                                  isString: boolean = false): any {
        const array = this.enumToArray<E>(Enum, exclude, isString);

        const result: any = {};

        for (const item of array) {
            result[(item.Id as undefined as string).toString()] = item.Name;
        }

        return result;
    }
}


// WEBPACK FOOTER //
// ./app/common/utils/EnumUtil.ts